<template>
  <div
    :class="[
      disclosureOpened ? '!shadow-cards_hover' : '',
      smallSize ? 'xxl:min-w-[572px] margin-s-auto' : '',
      sale.site && sale.site.no_website_sales
        ? 'opacity-50 pointer-events-none select-none'
        : '',
    ]"
    class="relative w-full flex flex-col bg-white border border-grays-400 rounded shadow-cards overflow-hidden hover:shadow-cards_hover"
  >
    <Disclosure
      v-if="sale.closed_for_orders == 1"
      v-slot="{ open }"
      as="div"
      class="absolute inset-0 z-10 flex flex-col items-center justify-center pointer-events-auto bg-white bg-opacity-80"
    >
      <div class="flex flex-col items-center text-center px-[28px] gap-[10px]">
        <p class="text-base font-bold text-error">
          מצטערים, אבל המכירה הזו סגורה כרגע להזמנות.
        </p>
        <DisclosureButton
          v-if="sale.reason_for_closing"
          class="flex flex-row items-center gap-[4px] text-primary-700 font-medium text-sm hover:underline"
        >
          <span>רוצים לדעת למה?</span>
        </DisclosureButton>
        <DisclosurePanel v-if="sale.reason_for_closing">
          <p class="text-base text-grays-700">
            {{ sale.reason_for_closing }}
          </p>
        </DisclosurePanel>
      </div>
    </Disclosure>
    <div
      :class="
        sale.closed_for_orders == 1
          ? 'opacity-50 pointer-events-none select-none'
          : ''
      "
      class="flex flex-col flex-1"
    >
      <div
        :class="[
          smallSize ? 'items-baseline !px-[20px] py-[24px] pb-[19px]' : '',
          bannerStyle ? 'sale-banner' : '',
        ]"
        :style="bannerStyle"
        class="relative w-full h-fit flex flex-row items-center justify-between bg-primary-800 px-[28px] py-[15px]"
      >
        <div
          :class="smallSize ? 'flex-col' : ''"
          class="xl:flex flex-row gap-[19px] mb-[20px] xl:mb-[0]"
        >
          <div class="flex flex-row gap-[8px]">
            <div class="flex flex-col">
              <h1 class="lg:text-2xl text-grays-200 font-bold my-[-5px]">
                {{ $saleName(sale) }}
              </h1>
              <p class="text-base text-grays-200 font-light mt-[5px]">
                {{
                  sale.parent.description && sale.parent.description.trim()
                    ? sale.parent.description
                    : "המכירה השבועית"
                }}
              </p>
            </div>
          </div>
          <div
            :class="smallSize ? 'lg:right-[44px]' : ''"
            class="relative flex flex-col gap-[8px]"
          >
            <p class="font-medium text-sm text-grays-600 mt-5 lg:mt-0">
              המערכת נסגרת
            </p>
            <div class="md:flex flex-row gap-[16px]">
              <div class="flex flex-row items-center gap-[4px]">
                <span
                  class="material-symbols-rounded text-white text-[16px] leading-[16px] flex"
                  >calendar_month</span
                >
                <p class="text-base font-regular text-white">
                  {{ moment(sale.end).format("dddd") }} {{ jDate(sale.end) }}
                  {{ moment(sale.end).format("DD/MM/Y") }}
                </p>
              </div>
              <div class="flex flex-row items-center gap-[4px]">
                <span
                  class="material-symbols-rounded text-white text-[16px] leading-[16px] flex"
                  >schedule</span
                >
                <p class="text-base font-medium text-white">
                  {{ moment(sale.end).format("LT a") }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <button-cta class="relative" @click="startOrder(sale.id)">
          <span class="material-symbols-rounded text-[20px]"
            >shopping_cart</span
          >
          <span v-if="isLoading">טוען נתונים...</span>
          <span v-else-if="sale.saleOpened" class=""> להמשיך בהזמנה</span>
          <span v-else>התחל הזמנה</span>
          <div
            v-if="sale.itemsInCart"
            class="absolute bg-error top-1 right-2 h-4 w-4 rounded-full flex items-center justify-center"
          >
            <span class="text-[10px] text-white font-medium leading-none">{{
              sale.itemsInCart < 100 ? sale.itemsInCart : "99+"
            }}</span>
          </div>
        </button-cta>
      </div>
      <div
        :class="smallSize ? 'pt-[30px] pb-[20px] !px-[20px]' : ''"
        class="xl:flex flex-row gap-[40px] pt-[32px] pb-[13px] px-[76px] flex-1"
      >
        <div class="flex flex-none flex-col xl:w-[140px]">
          <p class="text-sm font-medium text-grays-600">יום איסוף</p>
          <p class="text-base font-regular text-grays-900">
            {{ moment(sale.supply_begin).format("dddd") }}
          </p>
          <p class="text-base font-regular text-grays-900">
            {{ jDate(sale.supply_begin) }}
            {{ moment(sale.supply_begin).format("DD/MM/Y") }}
          </p>
          <div
            v-if="sale.day_diff"
            class="bg-error text-white text-sm font-medium px-[8px] py-[3px] rounded my-2 lg:my-0 inline-block"
          >
            <span class="material-symbols-rounded text-xs">error</span>
            שינוי ביום
          </div>
        </div>

        <div
          v-if="
            sale.general_end !== '00:00:00' ||
            sale.general_start !== '00:00:00' ||
            sale.women_end !== '00:00:00' ||
            sale.women_start !== '00:00:00' ||
            sale.men_end !== '00:00:00' ||
            sale.men_start !== '00:00:00'
          "
          class="flex flex-none flex-col xl:w-[140px]"
        >
          <p class="text-sm font-medium text-grays-600">שעה</p>
          <p
            v-if="
              sale.general_end !== '00:00:00' ||
              sale.general_start !== '00:00:00'
            "
            class="text-base font-regular text-grays-900"
          >
            כללי
            {{ moment(sale.general_start, "HH:mm:ss").format("HH:mm") }}
            {{ moment(sale.general_end, "HH:mm:ss").format("HH:mm") }}
          </p>
          <div>
            <p
              v-if="
                sale.women_end !== '00:00:00' || sale.women_start !== '00:00:00'
              "
              class="text-base font-regular text-grays-900"
            >
              נשים
              {{ moment(sale.women_start, "HH:mm:ss").format("HH:mm") }} -
              {{ moment(sale.women_end, "HH:mm:ss").format("HH:mm") }}
            </p>
            <p
              v-if="
                sale.men_end !== '00:00:00' || sale.men_start !== '00:00:00'
              "
              class="text-base font-regular text-grays-900"
            >
              גברים
              {{ moment(sale.men_start, "HH:mm:ss").format("HH:mm") }} -
              {{ moment(sale.men_end, "HH:mm:ss").format("HH:mm") }}
            </p>
          </div>
          <div
            v-if="sale.time_diff"
            class="bg-error text-white text-sm font-medium px-[8px] py-[3px] rounded my-2 lg:my-0 inline-block"
          >
            <span class="material-symbols-rounded text-xs">error</span>
            שינוי בשעה
          </div>
        </div>
        <div class="flex flex-col xl:w-[auto] ml-2">
          <p class="text-sm font-medium text-grays-600">מיקום</p>
          <p class="text-base font-regular text-grays-900">
            <template v-if="sale.special_address">
              <span class="truncate truncate-2-rows">
                {{ sale.special_address }} {{ sale.site.city }}
              </span>
              <div
                v-if="sale.time_diff"
                class="bg-error text-white text-sm font-medium px-[8px] py-[3px] rounded my-2 lg:my-0 inline-block"
              >
                <span class="material-symbols-rounded text-xs">error</span>
                שינוי התחנה יעודכן במכירה הבאה
              </div>
            </template>
            <template v-else>
              {{ sale.site.street }}, {{ sale.site.city }}.
              {{ sale.site.address_description }}
            </template>
          </p>
        </div>
      </div>
      <div class="flex flex-col">
        <Disclosure v-slot="{ open }" as="div">
          <div
            :class="smallSize ? '!px-[20px]' : ''"
            class="w-ful flex flex-col border-t border-grays-400 px-[76px]"
          >
            <DisclosureButton
              :class="smallSize ? 'justify-between h-[77px]' : ''"
              class="flex flex-row-reverse items-center justify-end gap-[8px] h-[83px]"
              @click="triggerDisclosure"
            >
              <button
                class="group w-7 h-7 rounded-md flex justify-center items-center bg-primary-400 hover:bg-primary-100 focus:bg-purple_semantic active:bg-purple_semantic disabled:bg-grays-400"
              >
                <span
                  :class="open ? 'rotate-180' : ''"
                  class="material-symbols-rounded text-xl text-primary-700 group-disabled:text-grays-600"
                  >expand_more</span
                >
              </button>
              <p class="text-lg text-primary-700 font-medium">
                קטגוריות במכירה
              </p>
            </DisclosureButton>
            <DisclosurePanel
              :class="smallSize ? 'pb-[24px]' : ''"
              class="pb-[27px]"
            >
              <categories-menu-view :categoriesList="sale.categories" />
            </DisclosurePanel>
          </div>
        </Disclosure>
      </div>
    </div>
  </div>
</template>

<script>
import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/vue";
import moment from "moment";
import "moment/dist/locale/he";

import dayjs from "dayjs";
import "dayjs/locale/he";

import hebrewDate from "hebrew-date";
import ButtonCta from "@/components/Global/ButtonCTA.vue";
import CategoriesMenuView from "@/components/Global/CategoriesMenuView.vue";
import { mapActions } from "vuex";

export default {
  components: {
    CategoriesMenuView,
    ButtonCta,
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
  },
  name: "card-sale",
  props: {
    smallSize: {
      type: Boolean,
      default: false,
    },
    sale: {
      type: Object,
      required: true,
    },
    clientId: String,
    debts: {
      type: Array,
      default: [],
      required: false,
    },
    cardsCount: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      disclosureOpened: false,
      isLoading: false,
      noWebsiteSalesExpanded: false,
    };
  },
  methods: {
    ...mapActions({
      toggleDebtsModal: "debtsModule/toggleIsModalVisible",
      toggleNoCreditCardModal: "noCreditCardModal/toggleIsModalVisible",
    }),
    triggerDisclosure() {
      this.disclosureOpened = !this.disclosureOpened;
      if (this.disclosureOpened) {
        this.$gtag?.event("sale_categories_open", { sale_status: "active" });
      }
    },
    moment: function (param1, param2) {
      return moment(param1, param2);
    },
    jDate: function (date) {
      const months = [
        "תשרי",
        "חשוון",
        "כסליו",
        "טבת",
        "שבט",
        "אדר א",
        "אדר ב",
        "ניסן",
        "אייר",
        "סיון",
        "תמוז",
        "אב",
        "אלול",
      ];
      const days = [
        "א",
        "ב",
        "ג",
        "ד",
        "ה",
        "ו",
        "ז",
        "ח",
        "ט",
        "י",
        "יא",
        "יב",
        "יג",
        "יד",
        "טו",
        "טז",
        "יז",
        "יח",
        "יט",
        "כ",
        "כא",
        "כב",
        "כג",
        "כד",
        "כה",
        "כו",
        "כז",
        "כח",
        "כט",
        "ל",
      ];
      const years = {
        5781: "תשפ״א",
        5783: "תשפ״ג",
        5782: "תשפ״ב",
        5784: "תשפ״ד",
        5785: "תשפ״ה",
        5786: "תשפ״ו",
        5787: "תשפ״ז",
        5788: "תשפ״ח",
      };
      const y = Number(dayjs(date, "YYYY-MM-DD").format("YYYY"));
      const m = dayjs(date, "YYYY-MM-DD").format("M") - 1;
      const d = Number(dayjs(date, "YYYY-MM-DD").format("D"));
      // const day = dayjs(date, "YYYY-MM-DD").locale('he').format("dddd");
      // @ts-ignore
      return (
        days[hebrewDate(new Date(y, m, d)).date - 1] +
        " " +
        months[hebrewDate(new Date(y, m, d)).month - 1]
      );
    },
    async startOrder(saleID) {
      this.$store.commit("order/setIsOnlyCard", this.sale.site.card_only);
      this.$store.commit("order/setSale", this.sale);

      if (this.cardsCount < 1 && this.sale.site.card_only) {
        await this.toggleNoCreditCardModal();
        return void 0;
      }
      if (this.debts.length) {
        await this.toggleDebtsModal();
        return void 0;
      }
      this.isLoading = true;
      try {
        if (this.sale.saleOpened) {
          this.$store.commit("order/setIsOnlyCard", this.sale.site.card_only);
          this.$store.commit("order/setSaleID", saleID);
          this.$router.push(`order/${this.sale.order.id}/${saleID}`);
        } else {
          this.$store.commit("order/setSaleID", saleID);
          this.$store.dispatch("order/toggleShowAgreement");
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.isLoading = false;
      }
    },
    getCartProducts(products) {
      return products.filter((product) => product.amount >= 1);
    },
    async getAllProduct() {
      // const response = await axiosInstance.get(`/get_items_for_sale/${this.$route.params.orderID}/null`);
      // this.fetchedProductsData = response.data;
      // const length = this.getCartProducts(this.fetchedProductsData);
    },
  },
  computed: {
    ...mapActions({
      updateCart: "cart/updateCart",
    }),
    /**
     * The custom header banner uploaded in KT, handed to CSS as custom
     * properties so the media query in the style block picks the variant.
     * Each side falls back to the other, so uploading only one image still
     * covers both widths. Null when nothing was uploaded, which leaves the
     * plain bg-primary-800 header in place.
     */
    bannerStyle() {
      const banners = this.sale.parent && this.sale.parent.banners;
      const desktop = (banners && (banners.desktop || banners.mobile)) || null;
      const mobile = (banners && (banners.mobile || banners.desktop)) || null;

      if (!desktop) {
        return null;
      }

      return {
        "--sale-banner-desktop": `url("${desktop}")`,
        "--sale-banner-mobile": `url("${mobile}")`,
      };
    },
  },
  mounted() {
    this.getAllProduct();
  },
};
</script>

<style scoped>
/* Custom sale banner (parent.banners) covering the purple card header. The
   mobile upload is the default; the desktop one takes over from md up.
   The artwork is drawn for the widest the card ever gets, so it is pinned to
   the left edge and anything that does not fit is cropped off the right. The
   left/right here are physical, not flipped by the RTL direction, which is
   what we want: the motif lives on the left of the artwork either way. */
.sale-banner {
  background-image: var(--sale-banner-mobile);
  background-repeat: no-repeat;
  background-position: left center;
  background-size: cover;
}

@media (min-width: 768px) {
  .sale-banner {
    background-image: var(--sale-banner-desktop);
  }
}
</style>